module.exports = __webpack_public_path__ + "static/img_9408-c2147692e48f7d42fa48730e2da3e202.webp";